module.exports = __webpack_public_path__ + "img/pdf.a8443193.svg";